module.exports = __webpack_public_path__ + "img/perforaciones_9-16_810.a8b4fc7b.jpg";